// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ja-0";
export var fileList = "_ja-2";
export var removeFileButton = "_ja-1";